import React from 'react';
import { LineChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Line, Legend } from 'recharts';
import { Space } from 'antd';
import { StringUtils } from '../../utils/strings';
import { SimpleDateUtils } from '../../utils/dates';
import CustomTooltip from './customTooltip';

const BiaxialChart = ({fullData}) => {
    return (
      <Space direction='vertical'>
        <Space direction='horizontal' style={{padding: 0}}>
            <div className="half-screen-chart">
                <h3>Impressions trend</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/> 
                        <YAxis yAxisId="right" orientation="right" />
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="impressionsCurrent" stroke="#3f35d1ff" activeDot={{ r: 8 }} />
                        <Line yAxisId="left" type="linear" dataKey="impressionsReference" stroke="#3f35d1ff" strokeDasharray="3 3" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className="half-screen-chart">
                <h3>CPM trend</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/> 
                        <YAxis yAxisId="right" orientation="right" />
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="cpmCurrent" stroke="#3f35d1ff" />
                        <Line yAxisId="left" type="linear" dataKey="cpmReference" stroke="#3f35d1ff" strokeDasharray="3 3" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Space>
         <Space direction='horizontal' style={{padding: 0}}>
            <div className="half-screen-chart">
                <h3>Revenue trend</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/>
                        <YAxis yAxisId="right" orientation="right" />
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="revenueCurrent" stroke="#3f35d1ff" activeDot={{ r: 8 }} />
                        <Line yAxisId="left" type="linear" dataKey="revenueReference" stroke="#3f35d1ff" strokeDasharray="3 3" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className="half-screen-chart">
                <h3>Revenue vs CPM</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/>
                        <YAxis yAxisId="right" orientation="right" />
                        <Legend verticalAlign="bottom" height={10}/>
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="revenueCurrent" stroke="#40cca2ff" activeDot={{ r: 8 }} />
                        <Line yAxisId="right" type="linear" dataKey="cpmCurrent" stroke="#3f35d1ff" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Space>
        <Space direction='horizontal' style={{padding: 0}}>
            <div className="half-screen-chart">
                <h3>Impressions vs CPM</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/>
                        <YAxis yAxisId="right" orientation="right" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)} />
                        <Legend verticalAlign="bottom" height={10}/>
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="impressionsCurrent" stroke="#40cca2ff" activeDot={{ r: 8 }} />
                        <Line yAxisId="right" type="linear" dataKey="cpmCurrent" stroke="#3f35d1ff" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className="half-screen-chart">
                <h3>Impressions vs Revenue</h3>
                <ResponsiveContainer>
                    <LineChart 
                        width={500} 
                        height={400}
                        data={fullData}
                        margin={{
                            top: 30,
                            right: 30,
                            left: 0,
                            bottom: 30,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="date" 
                            tickFormatter={(dateStr) => SimpleDateUtils.getShoterFriendlyDate(dateStr)}
                        />
                        <YAxis yAxisId="left" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/>
                        <YAxis yAxisId="right" orientation="right" tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)} />
                        <Legend verticalAlign="bottom" height={10}/>
                        <Tooltip content={<CustomTooltip totals={false}/>}/>
                        <Line yAxisId="left" type="linear" dataKey="impressionsCurrent" stroke="#40cca2ff" activeDot={{ r: 8 }} />
                        <Line yAxisId="right" type="linear" dataKey="revenueCurrent" stroke="#3f35d1ff" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Space>
    </Space>
    );
}

export default BiaxialChart;